var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("app-misc-settings", { attrs: { value: _vm.value } }),
      _c("app-asked-filter", { attrs: { value: _vm.value, model: _vm.model } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }